/*
 * Scroll-reveal fail-safe.
 *
 * The theme hides `.anm-fade-element` (visibility:hidden; opacity:0) and pauses
 * `.anm-move-up` until Alpine's `x-intersect` adds `.is-visible` /
 * `.active-anm-heading`. When that IntersectionObserver callback does not fire
 * — observed on iOS Safari — the content stays permanently invisible, which
 * reads as a large empty block on the page.
 *
 * This runs a cheap geometry check on scroll/resize and reveals any element
 * that is already inside the viewport but still hidden. Browsers where the
 * observer works are unaffected: those elements already carry the class, so the
 * selector never matches them and the animation plays exactly as designed.
 */
(function () {
  'use strict';

  var SELECTOR =
    '.anm-fade-element:not(.is-visible), .anm-move-up:not(.active-anm-heading)';
  var MARGIN = 100; // px of slack, mirrors the theme's own intersect margins
  var scheduled = false;

  function reveal(el) {
    if (el.classList.contains('anm-fade-element')) el.classList.add('is-visible');
    if (el.classList.contains('anm-move-up')) el.classList.add('active-anm-heading');
  }

  function sweep() {
    scheduled = false;
    var pending = document.querySelectorAll(SELECTOR);
    if (!pending.length) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < pending.length; i++) {
      var el = pending[i];
      var rect = el.getBoundingClientRect();
      // Skip elements with no layout box yet (inside a closed drawer, tab, etc.)
      if (rect.width === 0 && rect.height === 0) continue;
      if (rect.top < viewportHeight + MARGIN && rect.bottom > -MARGIN) reveal(el);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(sweep);
  }

  function start() {
    schedule();
    // Re-check once layout settles (webfonts, lazy images, app blocks).
    window.setTimeout(schedule, 1200);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
